import { useScrollReveal } from '@/hooks/useScrollReveal';
import HeroSection from '@/components/landing/HeroSection';
import BenefitsSection from '@/components/landing/BenefitsSection';
import HowItWorksSection from '@/components/landing/HowItWorksSection';
import AppShowcaseSection from '@/components/landing/AppShowcaseSection';
import PricingSection from '@/components/landing/PricingSection';
import WhySection from '@/components/landing/WhySection';
import CTASection from '@/components/landing/CTASection';

export default function HomePage() {
  useScrollReveal();

  return (
    <div>
      <HeroSection />
      <BenefitsSection />
      <HowItWorksSection />
      <AppShowcaseSection />
      <PricingSection />
      <WhySection />
      <CTASection />
    </div>
  );
}
